import { render } from "./devices.harvesterhci.io.sriovnetworkdevice.vue?vue&type=template&id=1ccd4d60"
import script from "./devices.harvesterhci.io.sriovnetworkdevice.vue?vue&type=script&lang=js"
export * from "./devices.harvesterhci.io.sriovnetworkdevice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__